<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">정책 목록</div>
        <div class="setting-addel">
          <el-button size="mini" @click="openRuleSettingPopup('ADD')"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="onDeleteButton" :disabled="!checkedRows.length"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="ruleTable" :column-default="columnDefault" :data="ruleDatas" :columns="ruleColumns" highlight-current-row
      :show-search-tool="showSearchTool" :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total"
      @row-click="onRowClick" @row-dblclick="onRowDblclick" @selection-change="onSelectionChange" @condition-change="loadData">
    </el-table-wrapper>
    <w-virtuallog-rule-setting-popup ref="ruleSettingPopup" :popup-params="popupParams" @reload="loadData" />
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import virtuallogSettingAPI from '@/api/settings/log/virtuallog-settings';
import WVirtuallogRuleSettingPopup from '../popup/VirtuallogRuleSettingPopup';

export default {
  name: 'WVirtuallogRuleTable',
  components: {
    WVirtuallogRuleSettingPopup,
  },
  data() {
    const ruleColumns = [
      {
        align: 'center',
        type: 'selection',
      },
      {
        prop: 'hypervisorType',
        label: '하이퍼바이저 종류',
        width: 200,
        searchable: true,
        sortable: true,
        remoteProp: 'basicinfo_subname',
        formatter: this.getStringFormatter,
      },
      {
        prop: 'logPolicyName',
        label: '정책 명',
        width: 200,
        searchable: true,
        sortable: true,
        remoteProp: 'log_policy_name',
        formatter: this.getStringFormatter,
      },
      {
        prop: 'logPolicyDesc',
        label: '정책 설명',
        searchable: true,
        remoteProp: 'log_policy_desc',
        sortable: true,
      },
      {
        prop: 'orderbyIndex',
        label: '정렬 순서',
        width: 100,
        sortable: true,
      },
    ];
    return {
      total: null,
      selectedRow: null,
      popupParams: {},
      ruleDatas: [],
      ruleColumns,
      checkedRows: [],
      showSearchTool: false,
      columnDefault,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 가상화 로그 정책 목록 조회
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      const tableParams = this.$refs.ruleTable.getParameter();
      virtuallogSettingAPI.getVirtualLogRuleList(tableParams).then((response) => {
        this.ruleDatas = response.data.data;
        this.total = response.data.total;
        this.$nextTick(() => {
          if (this.ruleDatas.length > 0) {
            this.$refs.ruleTable.getTable().setCurrentRow(this.ruleDatas[0]);
            this.onRowClick(this.ruleDatas[0]);
          } else {
            this.onRowClick(null);
          }
        });
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그 정책 목록', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    /**
     * 가상화 로그 정책 삭제
     * @author jeee12
     * @return {[type]} [description]
     */
    onDeleteButton() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        virtuallogSettingAPI.deleteVmsLogPolicy(this.checkedRows).then((response) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '로그 정책', response.data.success));
          if (response.data.success) {
            this.loadData();
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '로그 정책', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    onRowClick(row) {
      this.$emit('target-change', row);
    },
    /**
     * 테이블 row 더블 클릭
     * @author jeee12
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowDblclick(row) {
      this.openRuleSettingPopup('UPDATE', row);
    },
    /**
     * 로그 정책 설정 팝업 open
     * @author jeee12
     * @param  {[type]} popupType   [description]
     * @param  {[type]} selectedRow [description]
     * @return {[type]}             [description]
     */
    openRuleSettingPopup(popupType, selectedRow) {
      this.popupParams = { popupType };
      if (!isEmpty(selectedRow)) {
        this.popupParams.selectedRow = selectedRow;
        this.popupParams.orderbyIndex = selectedRow.orderbyIndex;
      } else {
        const orderbyIndex = this.ruleDatas.length > 0 ? this.ruleDatas[this.ruleDatas.length - 1].orderbyIndex : 0;
        this.popupParams.orderbyIndex = orderbyIndex + 1;
      }
      this.$refs.ruleSettingPopup.open();
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Virtuallog/components/VirtuallogRuleTable.vue